import { render, staticRenderFns } from "./BaseMetricsDetail.vue?vue&type=template&id=2565a4d2&scoped=true"
import script from "./BaseMetricsDetail.vue?vue&type=script&lang=js"
export * from "./BaseMetricsDetail.vue?vue&type=script&lang=js"
import style0 from "./BaseMetricsDetail.vue?vue&type=style&index=0&id=2565a4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565a4d2",
  null
  
)

export default component.exports